import { LotTypes } from '~/enums/lots'
import { Lot, LotInfo } from '~/models'

const isHome = (lot: Lot | LotInfo): boolean => {
  if (lot?.architectural_submission) {
    return false
  }

  return lot.type === LotTypes.HOME
}

const isHomesite = (lot: Lot | LotInfo): boolean => {
  return lot.type === LotTypes.HOME_SITE
}

export { isHome, isHomesite }
